import React, { Component } from "react";
import LoadingImage from "../../lib/image";

const DEFAULT_EPISODE_IMAGE =
  "https://s3.us-east-2.amazonaws.com/pod-public-media-files/ui/missing.png";

class EpisodeImage extends Component {
  componentDidMount() {
    this.fetch(this.props);
  }

  fetch = props => {
    props.fetchImage(props.imageMediaFileUUID, props.user.authToken);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.imageMediaFileUUID !== this.props.imageMediaFileUUID) {
      this.fetch(nextProps);
    }
  }

  render() {
    var imageURL =
      this.props.mediaFiles &&
      this.props.mediaFiles[this.props.imageMediaFileUUID] &&
      this.props.mediaFiles[this.props.imageMediaFileUUID].url;
    var isLoading =
      this.props.mediaFiles &&
      this.props.mediaFiles[this.props.imageMediaFileUUID] &&
      this.props.mediaFiles[this.props.imageMediaFileUUID].isLoading;
    return (
      <LoadingImage
        imageURL={imageURL}
        className={"loading-image " + this.props.className}
        defaultImage={DEFAULT_EPISODE_IMAGE}
        isLoading={isLoading}
        alt="Episode Image"
      />
    );
  }
}

export default EpisodeImage;
